module.exports = __webpack_public_path__ + "static/media/spotify.9b8e9a71.svg";